/**
 * A rota raiz — TanStack Router, roteamento **por arquivo** (ADR-0017).
 *
 * Ela monta o casco e nada mais. Toda tela e um arquivo irmao, e o plugin do Vite gera o
 * `routeTree.gen.ts` a partir desta pasta com `autoCodeSplitting` — que e como o
 * "divisao de codigo por rota" do `PWA §11.4` acontece sem uma lista de `React.lazy` escrita a
 * mao, que envelheceria em silencio.
 *
 * O `notFoundComponent` fica aqui porque uma rota inexistente e sempre da raiz: um atalho do
 * manifest apontando para uma tela que ainda nao existe cai neste componente, e nao numa tela
 * branca.
 */

import { EmptyState } from '@farmacia/ui';
import { Outlet, createRootRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { Shell } from '../app/shell/Shell.jsx';
import { texto } from '../conteudo/index.js';

export const Route = createRootRoute({
  component: Raiz,
  notFoundComponent: NaoEncontrado,
});

function Raiz(): ReactNode {
  return (
    <Shell>
      <Outlet />
    </Shell>
  );
}

function NaoEncontrado(): ReactNode {
  return (
    <EmptyState
      pictogram="erro"
      title={texto('erro.naoEncontrado.titulo')}
      primaryAction={{
        label: texto('erro.naoEncontrado.acao'),
        onPress: () => { window.location.assign('/'); },
      }}
    />
  );
}
